import React from 'react';
import { site } from '../data/site';
import { useSeo } from '../hooks/useSeo';
const blocs = [{
  titre: 'Éditeur du site',
  contenu: [`${site.nom} — organisme de formation professionnelle certifié Qualiopi.`, `Adresse : ${site.adresse}.`, `Contact : ${site.email} — ${site.telephone}.`, 'Forme juridique, numéro SIRET, numéro de déclaration d’activité et nom du responsable de publication : à renseigner avant mise en ligne.']
}, {
  titre: 'Hébergement',
  contenu: ['Nom et coordonnées de l’hébergeur du site : à renseigner avant mise en ligne.']
}, {
  titre: 'Propriété intellectuelle',
  contenu: [`L’ensemble des contenus de ce site (textes, supports pédagogiques, visuels, logo) est la propriété de ${site.nom}. Toute reproduction ou diffusion sans autorisation écrite est interdite.`]
}, {
  titre: 'Données personnelles',
  contenu: ['Les données transmises via le formulaire de contact sont utilisées uniquement pour traiter votre demande de formation et assurer le suivi de votre dossier. Elles ne sont ni cédées ni revendues.', `Vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression de vos données, exerçable à ${site.email}. La durée de conservation précise est à renseigner avant mise en ligne.`]
}, {
  titre: 'Conditions générales de vente',
  contenu: ['Les conditions générales de vente applicables à toute inscription sont remises avec le devis et les documents contractuels.']
}, {
  titre: 'Réclamations',
  contenu: [`Toute réclamation peut être adressée à ${site.email} ou par téléphone au ${site.telephone}. Les modalités et délais de traitement des réclamations sont à préciser avant mise en ligne.`]
}];
export function MentionsLegales() {
  useSeo({
    title: 'Mentions légales — Zillenium Academy',
    description: 'Mentions légales du site zilleniumacademy.fr — Zillenium Academy, organisme de formation professionnelle à Joigny (89).'
  });
  return <>
      <section className="border-b border-surface-line bg-surface-soft" data-id="element-445" data-mp="c4028mup7qv2">
        <div className="mx-auto max-w-content px-5 py-14 lg:px-8" data-id="element-446" data-mp="c644z1gv2jtr">
          <h1 className="text-4xl font-extrabold leading-tight text-ink md:text-[46px]" data-id="element-447" data-mp="q2hmgaleal88">
            Mentions légales
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-ink-muted" data-id="element-448" data-mp="m0321m22vdeu">
            Informations légales relatives au site {site.site} et à l’activité de formation de{' '}
            {site.nom}.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-8" data-id="element-449" data-mp="74ol3cqf6jcy">
        <div className="space-y-10" data-id="element-450" data-mp="7719a7mrtpyg">
          {blocs.map(b => <article key={b.titre} data-id="element-451" data-mp="2dewmfglxm2n">
              <h2 className="text-xl font-bold text-ink" data-id="element-452" data-mp="2cdk06jy0rit">{b.titre}</h2>
              <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-ink-muted" data-id="element-453" data-mp="3asgt8gqpeo99">
                {b.contenu.map(p => <p key={p} data-id="element-454" data-mp="36qlot3dh7ur9">{p}</p>)}
              </div>
            </article>)}
        </div>
        <p className="mt-12 rounded-lg border border-amber-200 bg-amber-50 px-5 py-4 text-sm leading-relaxed text-amber-800" data-id="element-455" data-mp="31ey8mjglyvso">
          Les éléments signalés « à renseigner avant mise en ligne » doivent être complétés avec vos
          informations officielles. Aucune donnée administrative n’a été inventée.
        </p>
      </section>
    </>;
}